import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34708952"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-section-title" }, [
  /*#__PURE__*/_createTextVNode(" 指定整備に関わる法令遵守の "),
  /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
  /*#__PURE__*/_createTextVNode(" ヒアリングシート ")
], -1))
const _hoisted_2 = { class: "row q-mb-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "拠点名", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "プジョー成城", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("dl", {
    class: "info flex",
    style: {"border-bottom":"none"}
  }, [
    /*#__PURE__*/_createElementVNode("dt", null, "報告者氏名"),
    /*#__PURE__*/_createElementVNode("dd", null, "須山 誠")
  ]),
  /*#__PURE__*/_createElementVNode("dl", { class: "info flex" }, [
    /*#__PURE__*/_createElementVNode("dt", null, [
      /*#__PURE__*/_createTextVNode("サービス "),
      /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
      /*#__PURE__*/_createTextVNode("責任者名")
    ]),
    /*#__PURE__*/_createElementVNode("dd", null, "須山 誠")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-py-md",
  style: {"font-size":"1.2rem"}
}, "【質問事項】", -1))
const _hoisted_8 = { class: "q-mb-lg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-bold q-mb-sm question-txt" }, "1. 指定自動車整備事業の指定を取得している", -1))
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_12 = { class: "question-radio" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "q-mb-xl" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-bold question-txt" }, [
  /*#__PURE__*/_createTextVNode(" 2. 上記指定自動車整備事業の指定番号※を記入して下さい"),
  /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-caption" }, "（※指定番号が複数ある場合は指定番号毎に本シートを作成願います）")
], -1))
const _hoisted_16 = { class: "q-mb-xl" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-bold q-mb-xs question-txt" }, [
  /*#__PURE__*/_createTextVNode(" 3. 直近の運輸支局の監査受審日を記入して下さい"),
  /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-caption" }, "（※監査を受審していない場合や不明の場合はその旨記入願います）")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-bold q-py-md question-txt" }, "下記4以降の質問で「いいえ」の場合は必ず理由/対策を記載して下さい", -1))
const _hoisted_19 = { class: "q-mb-lg" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"1em","text-indent":"-1em"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-bold question-txt" }, " 4."),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-bold question-txt",
    style: {"text-decoration":"underline"}
  }, "現場業務の負担について"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" サービス部門の処理能力を超える業務量であったり、車検の作業時間が固定され無理な作業を強いられているなど、車検を行うエンジニアが負担と感じる業務量となっていないか ")
], -1))
const _hoisted_21 = { class: "flex q-mt-sm" }
const _hoisted_22 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_23 = { class: "question-radio" }
const _hoisted_24 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 理由/対策を記載して下さい ")
const _hoisted_26 = { class: "q-mb-lg" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"1em","text-indent":"-1em"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-bold question-txt" }, [
    /*#__PURE__*/_createTextVNode("5."),
    /*#__PURE__*/_createElementVNode("span", {
      class: "question-txt",
      style: {"text-decoration":"underline"}
    }, "安全に対する意識と車検制度に対するコンプライアンスについて")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 販売会社の経営層、店舗の管理職や従業員が、「国の業務を代行している」という民間車検制度（指定自動車整備事業制度）の役割の重要性を認識しているか。 ")
], -1))
const _hoisted_28 = { class: "flex q-mt-sm" }
const _hoisted_29 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_30 = { class: "question-radio" }
const _hoisted_31 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 理由/対策を記載して下さい ")
const _hoisted_33 = { class: "q-mb-lg" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"1em","text-indent":"-1em"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-bold question-txt" }, " 6. "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-bold question-txt",
    style: {"text-decoration":"underline"}
  }, "経営層・管理者と現場との意思疎通について"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 販売会社の経営層、店舗の管理者がサービス部門の現場の実態を十分把握しているか。また、サービス部門のエンジニアが、抱えている問題や改善提案を上層部へ伝えやすい環境となっているか ")
], -1))
const _hoisted_35 = { class: "flex q-mt-sm" }
const _hoisted_36 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_37 = { class: "question-radio" }
const _hoisted_38 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 理由/対策を記載して下さい ")
const _hoisted_40 = { class: "q-mb-lg" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"1em","text-indent":"-1em"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-bold question-txt" }, "7. "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-bold question-txt",
    style: {"text-decoration":"underline"}
  }, "社内監査について"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 社内監査を実施しているか。また、社内監査が実質的に機能し、車検に関するコンプライアンスの確実な執行状況を把握できているか。 ")
], -1))
const _hoisted_42 = { class: "flex q-mt-sm" }
const _hoisted_43 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_44 = { class: "question-radio" }
const _hoisted_45 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 理由/対策を記載して下さい ")
const _hoisted_47 = { class: "q-mb-lg" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"1em","text-indent":"-1em"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-bold question-txt" }, "8. "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-bold question-txt",
    style: {"text-decoration":"underline"}
  }, "顧客への説明について"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 車検時間が一律であるとの誤解を招くような広告となっていないか。また、顧客に対し、車両の状況により予定時間内に作業が完了しない場合があることなどの説明が十分に行われているか。 ")
], -1))
const _hoisted_49 = { class: "flex q-mt-sm" }
const _hoisted_50 = {
  class: "question-radio",
  style: {"margin-right":"16px"}
}
const _hoisted_51 = { class: "question-radio" }
const _hoisted_52 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 理由/対策を記載して下さい ")
const _hoisted_54 = {
  key: 0,
  class: "text-center text-bold q-pt-md question-txt"
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 上記質問１で「いいえ」の場合は、これで終了です。 ")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 上記質問１で「はい」の場合は、下記2以降の質問に進みます ")
const _hoisted_58 = [
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "row justify-center q-pb-sm",
  style: {"margin-top":"36px"}
}

import { reactive } from 'vue'

// TODO: データの持ち方は仮

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const answer = reactive({
  first: null,
  second: null,
  third: {
    a: null,
    b: null,
    text: '',
  },
  four: {
    a: null,
    text: '',
  },
  five: {
    a: null,
    text: '',
  },
  six: {
    a: null,
    text: '',
  },
  seven: {
    a: null,
    text: '',
  },
  eight: {
    a: null,
    text: '',
  },
})

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dl", {
        class: "info col-12 col-sm-6 flex",
        style: _normalizeStyle(_ctx.$q.screen.lt.sm ? 'border-bottom: none' : 'border-right: none')
      }, _hoisted_5, 4),
      _hoisted_6
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_q_radio, {
            style: {"width":"100%"},
            label: "はい",
            val: "1",
            modelValue: _unref(answer).first,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(answer).first) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_q_radio, {
            style: {"width":"100%"},
            label: "いいえ",
            val: "2",
            modelValue: _unref(answer).first,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(answer).first) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(answer).first == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_q_input, {
                  style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                  class: "q-mt-sm",
                  prefix: "指定番号：",
                  outlined: "",
                  type: "text",
                  modelValue: _unref(answer).second,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(answer).second) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_q_input, {
                  label: "監査受審日",
                  "stack-label": "",
                  type: "date",
                  outlined: "",
                  modelValue: _unref(answer).third.b,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(answer).third.b) = $event)),
                  class: "q-mb-md",
                  style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_input, {
                  label: "監査を受審していない場合や不明の場合の記入欄",
                  type: "textarea",
                  autogrow: "",
                  outlined: "",
                  dense: "",
                  "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                  modelValue: _unref(answer).third.text,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(answer).third.text) = $event)),
                  style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"}
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "はい",
                      val: "1",
                      modelValue: _unref(answer).four.a,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(answer).four.a) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "いいえ",
                      val: "2",
                      modelValue: _unref(answer).four.a,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(answer).four.a) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(answer).four.a == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(_component_q_input, {
                            class: "q-mt-xs",
                            label: "理由/対策",
                            style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                            type: "textarea",
                            autogrow: "",
                            outlined: "",
                            dense: "",
                            "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                            modelValue: _unref(answer).four.text,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(answer).four.text) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "はい",
                      val: "1",
                      modelValue: _unref(answer).five.a,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(answer).five.a) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "いいえ",
                      val: "2",
                      modelValue: _unref(answer).five.a,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(answer).five.a) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(answer).five.a == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode(_component_q_input, {
                            class: "q-mt-xs",
                            label: "理由/対策",
                            style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                            type: "textarea",
                            autogrow: "",
                            outlined: "",
                            dense: "",
                            "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                            modelValue: _unref(answer).five.text,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(answer).five.text) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "はい",
                      val: "1",
                      modelValue: _unref(answer).six.a,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(answer).six.a) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "いいえ",
                      val: "2",
                      modelValue: _unref(answer).six.a,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(answer).six.a) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(answer).six.a == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createVNode(_component_q_input, {
                            class: "q-mt-xs",
                            label: "理由/対策",
                            style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                            type: "textarea",
                            autogrow: "",
                            outlined: "",
                            dense: "",
                            "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                            modelValue: _unref(answer).six.text,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(answer).six.text) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "はい",
                      val: "1",
                      modelValue: _unref(answer).seven.a,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(answer).seven.a) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "いいえ",
                      val: "2",
                      modelValue: _unref(answer).seven.a,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(answer).seven.a) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(answer).seven.a == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode(_component_q_input, {
                            class: "q-mt-xs",
                            label: "理由/対策",
                            style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                            type: "textarea",
                            autogrow: "",
                            outlined: "",
                            dense: "",
                            "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                            modelValue: _unref(answer).seven.text,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(answer).seven.text) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "はい",
                      val: "1",
                      modelValue: _unref(answer).eight.a,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(answer).eight.a) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_q_radio, {
                      style: {"width":"100%"},
                      label: "いいえ",
                      val: "2",
                      modelValue: _unref(answer).eight.a,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(answer).eight.a) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(answer).eight.a == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _hoisted_53,
                          _createVNode(_component_q_input, {
                            class: "q-mt-xs",
                            label: "理由/対策",
                            style: {"border":"2px solid rgb(54, 78, 150)","border-radius":"8px"},
                            type: "textarea",
                            autogrow: "",
                            outlined: "",
                            dense: "",
                            "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                            modelValue: _unref(answer).eight.text,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(answer).eight.text) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(answer).first == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_58))
      : _createCommentVNode("", true),
    (_unref(answer).first !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createVNode(_component_q_btn, {
            style: {"max-width":"357px","width":"100%"},
            unelevated: "",
            color: "primary",
            label: "回答を完了する"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})